module.exports = __webpack_public_path__ + "static/media/Sandygast_gaussian2.979c6e1f.png";